var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":_vm.$t('global.terms.search'),"placeholder":_vm.$t('invoices.terms.searchPlaceholder'),"solo":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})}
var staticRenderFns = []

export { render, staticRenderFns }